import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "./user/user.service";
import { role } from "./user/role.const";
import { NotifyService } from "./notify/notify.service";
import { TOAST } from "./notify/toast/toast-type.enum";
import {
  MS_GRAPH_ERROR_MESSAGES,
  MS_GRAPH_AUTO_ENABLE_KEY,
  MS_GRAPH_RETURN_URL_KEY,
} from "./user/ms-graph-error-messages.const";

@Component({ changeDetection: ChangeDetectionStrategy.Eager, template: "" })
export class AppRedirectComponent implements OnInit {
  private router = inject(Router);
  private userService = inject(UserService);
  private notifyService = inject(NotifyService);
  private activatedRoute = inject(ActivatedRoute);

  ngOnInit() {
    const params = this.activatedRoute.snapshot.queryParams;

    if (params["ms_connected"] === "1") {
      this.notifyService.toast(
        TOAST.INFO,
        "Office365 Connected",
        "Your Microsoft account has been successfully linked.",
      );
    } else if (params["ms_disconnected"] === "1") {
      this.notifyService.toast(
        TOAST.INFO,
        "Office365 Disconnected",
        "Your Microsoft account has been unlinked.",
      );
    } else if (params["ms_error"]) {
      // Clear any pending auto-enable flag — the connection failed.
      sessionStorage.removeItem(MS_GRAPH_AUTO_ENABLE_KEY);
      const errorMsg =
        MS_GRAPH_ERROR_MESSAGES[params["ms_error"]] ??
        "An error occurred while connecting to Office365. Please try again.";
      this.notifyService.toast(
        TOAST.ERROR,
        "Office365 Connection Failed",
        errorMsg,
      );
    }

    const isMsGraphReturn =
      params["ms_connected"] === "1" ||
      params["ms_disconnected"] === "1" ||
      !!params["ms_error"];

    const returnUrl = sessionStorage.getItem(MS_GRAPH_RETURN_URL_KEY);

    // When the user just completed a successful OAuth login and is returning to
    // their profile page, set a flag so UserFormEmailComponent can silently
    // enable mail integration if it wasn't enabled yet.
    if (
      params["ms_connected"] === "1" &&
      returnUrl &&
      /^\/user\/\d+/.test(returnUrl)
    ) {
      sessionStorage.setItem(MS_GRAPH_AUTO_ENABLE_KEY, "true");
    }

    if (isMsGraphReturn && returnUrl) {
      sessionStorage.removeItem(MS_GRAPH_RETURN_URL_KEY);
      this.router.navigateByUrl(returnUrl, { replaceUrl: true });
      return;
    }

    this.userService.getUser().then(
      (user) => {
        if (user === null || !user.hasRole(role.user)) {
          this.navigateTo("login");
          return;
        }
        if (user.hasRole(role.user)) {
          this.navigateTo("dashboard");
          return;
        }
      },
      (err) => {
        this.navigateTo("login");
      },
    );
  }

  public navigateTo(path: string) {
    this.router.navigate([path], { replaceUrl: true });
  }
}
